export default function YoutubeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.4">
        <path
          d="M5.375 20.5125C7.625 20.8125 9.9875 20.9625 12.5 20.9625C15.0125 20.9625 17.375 20.8125 19.625 20.5125C21.575 20.25 23 18.6 23 16.65V7.3125C23 5.3625 21.5375 3.7125 19.625 3.45C17.375 3.15 14.975 3 12.5 3C10.025 3 7.625 3.15 5.375 3.4875C3.4625 3.75 2 5.3625 2 7.3125V16.65C2 18.6375 3.4625 20.25 5.375 20.5125ZM10.1 10.275C10.1 9.2625 11.225 8.6625 12.0875 9.1875L15.0125 11.0625C15.6875 11.475 15.6875 12.45 15.0125 12.9L12.0875 14.775C11.225 15.3375 10.1 14.7 10.1 13.6875V10.275Z"
          fill="#F2F4F6"
        />
      </g>
    </svg>
  )
}
